import React from 'react';
import { Routes, Route, useLocation, Navigate, matchPath } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';

// Import Components
import Sidebar from './components/SidebarNav';
import Header from './components/Header';
import PrivateComponent from './components/PrivateComponent';
import AdminRoute from './components/AdminRoute'; // Protected Admin Route
import Dashboard from './components/Dashboard';
import Projects from './components/Projects';
import JunkProject from './components/JunkProject';
import CompletedProjects from './components/CompletedProjects';
import Assigned from './components/Assigned';
import ProjectView from './components/ProjectView';
import CompletedRooms from './components/CompletedRooms';
import AddRooms from './components/AddRooms';
import EditRooms from './components/EditRooms';
import ViewDesign from './components/ViewDesign';
import AddQuotation from './components/AddQuotation';
import Factory from './components/Factory';
import Inspiration from './components/Inspiration';
import Render from './components/Render';
import Services from './components/Services';
import Settings from './components/Settings';
import Team from './components/Team';
import ViewProfile from './components/ViewProfile';
import Notification from './components/Notification';
import Login from './components/Login';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/Admindashboard';
import ClientQuotation from './components/ClientQuotation';
import PriceList from './components/PriceList';
import PriceList2 from './components/PriceList2';
import PriceListKKT from './components/PriceListKKT';
import AdminDash from './components/AdminPages/AdminDash';
import Users from './components/AdminPages/Users'; // New Users Page
import ViewUserDetail from './components/AdminPages/ViewUserDetail';
import Internetconnection from './components/Internetconnection';
import { useNetworkStatus } from './components/NetworkProvider';
import ErrorPage from './components/ErrorPage';
import AdminPriceList from './components/AdminPages/AdminPriceList';
import LostProject from './components/LostProject';
import LostProjectsRoom from './components/LostProjectsRoom';
import AdminPriceRoom from './components/AdminPages/AdminPriceRoom';
import AssignedProjectView from './components/AssignedProjectView';
import ClientPDFview from './components/ClientPDFview';
import AssignAddRoom from './components/AssigneProject/AssignAddRoom';
import AssignedViewRoom from './components/AssigneProject/AssignedViewRoom';
import AssignedEditRoom from './components/AssignedEditRoom';
import AssigneAddQuotation from './components/AssigneAddQuotation';
import ClientQuotation2 from './components/ClientQuotation';
import QCuotation from './components/QC-Quotation';
import QCClientPDFview from './components/QC-ClientPDFview';
import { useForceLogout } from './hooks/useForceLogout';

function App() {
  const location = useLocation();
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
   const { isOnline  } = useNetworkStatus();
    const isQuotationPage = matchPath('/project/:clientId/quotations/:quotationId', location.pathname);
  const forceLogout = useForceLogout();
  return (
    <>
      {/* Hide Sidebar & Header on Login and Admin Pages */}
      {location.pathname !== '/login' &&
        location.pathname !== '/admin-login' &&
        location.pathname !== '/price-list' &&
        location.pathname !== '/price-list-2' &&
        location.pathname !== '/price-list-kkt' &&
        location.pathname !== '/ClientPDFview' &&
        location.pathname !== '/QC-ClientPDFview' &&
        !isQuotationPage &&
        !location.pathname.startsWith('/admin-dashboard') && isOnline  &&(
          <>
            <Sidebar />
            <Header />
          </>
        )}

         {/* Internet connection banner */}
         <Internetconnection isOnline={isOnline} />

         <Routes>
        {/* Show Error Page if offline */}
        {!isOnline   ? (
          <Route path="*" element={<ErrorPage />} />
        ) : (
          <>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/project/:clientId/quotations/:quotationId" element={<ClientQuotation2 />} />
            <Route path="/project/:clientId/QCuotation/:quotationId" element={<QCuotation />} />
         

            {/* Private Routes (Require Authentication) */}
            <Route element={<PrivateComponent />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/JunkProject" element={<JunkProject />} />
              <Route path="/completed" element={<CompletedProjects />} />
              <Route path="/projects/view-rooms" element={<ProjectView />} />
              <Route path="/completed/completed-rooms" element={<CompletedRooms />} />
              <Route path="/projects/view-rooms/add-rooms" element={<AddRooms />} />
              <Route path="/assignRoom/view-rooms/add-rooms" element={< AssignAddRoom />} />
              <Route path="/projects/view-rooms/edit-rooms" element={<EditRooms />} />
              <Route path="/assignRoom/view-rooms/edit-rooms" element={<AssignedEditRoom />} />
              <Route path="/projects/view-rooms/view-designs" element={<ViewDesign />} />
              <Route path="/completed/completed-rooms/view-designs" element={<ViewDesign />} />
              <Route path="/assignRoom/view-rooms/view-designs" element={<AssignedViewRoom />} />
              <Route path="/projects/view-rooms/add-quotation" element={<AddQuotation />} />
              <Route path="/assigned/view-rooms/add-quotation" element={<AssigneAddQuotation />} />
              <Route path="/factory" element={<Factory />} />
              <Route path="/inspiration" element={<Inspiration />} />
              <Route path="/render" element={<Render />} />
              <Route path="/services" element={<Services />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/team" element={<Team />} />
              <Route path="/viewprofile" element={<ViewProfile />} />
              <Route path="/notification" element={<Notification />} />
              <Route path="/lost" element={<LostProject />} />
              <Route path="/lost/lostprojectRoom" element={<LostProjectsRoom />} />
              <Route path="/assigned/view-rooms" element={<AssignedProjectView />} />
              <Route path="/assigned" element={<Assigned />} />
              <Route path="/ClientPDFview" element={<ClientPDFview />} />
              <Route path="/QC-ClientPDFview" element={<QCClientPDFview />} />
                 <Route path="/price-list" element={<PriceList />} />
                 <Route path="/price-list-2" element={<PriceList2 />} />
            <Route path="/price-list-kkt" element={<PriceListKKT />} />
            </Route>

            {/* Protected Admin Routes (Wrapped inside `AdminDashboard`) */}
            <Route element={<AdminRoute />}>
              <Route path="/admin-dashboard" element={<AdminDashboard />}>
                <Route index element={<AdminDash />} /> {/* Default Dashboard */}
                <Route path="users" element={<Users />} /> {/* Users Page */}
                <Route path="users/ViewUserDetail/:id" element={<ViewUserDetail />} /> 
                <Route path="AdminPriceList" element={<AdminPriceList />} /> 
                <Route path="AdminPriceRoom" element={<AdminPriceRoom />} /> 
              </Route>
            </Route>

            {/* Redirect any unknown routes to login */}
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}
      </Routes>
    </>
  );
}

export default App;
